import 'slick-carousel/slick/slick.min.js';

export default {
    init() {
        $(document).ready( function() {
            if ($(this).scrollTop() > 20) {
                $('body').addClass('has-scrolled');
            } else {
                $('body').removeClass('has-scrolled');
            }
        });

        $(window).scroll(function(){
            if ($(this).scrollTop() > 20) {
                $('body').addClass('has-scrolled');
            } else {
                $('body').removeClass('has-scrolled');
            }
        });

        $('#primary-navigation').on('show.bs.collapse', function () {
            setTimeout(function(){
               $('body').addClass('nav-open');
           }, 400);
        });

        $('#primary-navigation').on('hide.bs.collapse', function () {
            $('body').removeClass('nav-open');
        });

        // Carousels
        if ( $( '.js-partners-carousel' ).length ) {
            $('.js-partners-carousel').slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                dots: false,
                speed: 1000,
                slidesToShow: 8,
                slidesToScroll: 1,
                responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 7,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                    }
                }
                ]
            });
        }

        if ( $( '.js-partners-banner-carousel' ).length ) {
            $('.js-partners-banner-carousel').slick({
                infinite: true,
                autoplay: true,
                autoplaySpeed: 3000,
                arrows: false,
                dots: false,
                speed: 1000,
                slidesToShow: 10,
                slidesToScroll: 1,
                responsive: [
                {
                    breakpoint: 1140,
                    settings: {
                        slidesToShow: 9,
                    }
                },
                {
                    breakpoint: 1080,
                    settings: {
                        slidesToShow: 8,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 7,
                    }
                },
                {
                    breakpoint: 940,
                    settings: {
                        slidesToShow: 6,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                    }
                }
                ]
            });
        }

        if ( $( '.js-quotes-carousel' ).length ) {
            $('.js-quotes-carousel').slick({
                infinite: true,
                autoplay: false,
                arrows: true,
                dots: false,
                appendArrows: '.quotes-carousel__arrows',
                speed: 1000,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        }

        $('.tabs__nav-item').on('click', function() {
            if ($(window).width() < 992) {
                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: $('#tabsContent').offset().top - 150
                    }, 'fast');
                }, 300)
            }
        });

        $('.accordion-collapse').on('shown.bs.collapse', function () {
            $(this).closest('.accordion-item').addClass('is-open');
        })

        $('.accordion-collapse').on('hidden.bs.collapse', function () {
            $(this).closest('.accordion-item').removeClass('is-open');
        })

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js